export const environment = {
  production: false,
  apiUrl: 'https://claims-sparci-training.unilever.com',
  socketUrl:
    'https://bnlwe-es02-e-931435-unilevercom-webapp-01.azurewebsites.net',
  msalConfig: {
    auth: {
      clientId: '4a4bf3ca-b6fd-4974-b6b2-bbf16aa1f975',
      authority:
        'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
      // redirectUri: 'http://localhost:4200',
      redirectUri: 'https://claims-sparci-training.unilever.com/',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/.default',
  },
  // apiUrl: 'https://sparci-dev.unilever.com',

  // clientId: '955fde3e-e37e-42a7-98b3-64882b3e2aca',
  // tenantId: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
  // authority:
  //   'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
  // // redirectUri: 'http://localhost:4300/',
  // redirectUri: 'https://sparci-dev.unilever.com/.auth/login/aad/callback',
};
